import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./pages/NavBar/nav";
import Home from "./pages/Home/home";
import Project from "./pages/Projects/project";
import Contact from "./pages/Contact/contact";
import About from "./pages/About/about";
import ScrollIndicator from "./ScrollIndicator";
import Valentine from "./pages/secret/Valentine";
import "./App.css";

function MainPage() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const projectRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="App">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <header className="App-header">
        <Nav
          scrollToSection={scrollToSection}
          refs={{ homeRef, aboutRef, projectRef, contactRef }}
        />
        <ScrollIndicator refs={{ homeRef, aboutRef, projectRef, contactRef }} />
      </header>

      <main className="scroll-container" id="main-content">
        <section ref={homeRef} id="home" className="page-section page-home">
          <Home
            onContactClick={() => scrollToSection(contactRef)}
            onProjectClick={() => scrollToSection(projectRef)}
          />
        </section>

        <section ref={aboutRef} id="about" className="page-section page-about">
          <About />
        </section>

        <section
          ref={projectRef}
          id="projects"
          className="page-section page-projects"
        >
          <Project />
        </section>

        <section
          ref={contactRef}
          id="contact"
          className="page-section page-contact"
        >
          <Contact />
        </section>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/secret-Valentine" element={<Valentine />} />
      </Routes>
    </Router>
  );
}

export default App;
